import CityPageTemplate from "../city-template/CityPageTemplate";
import { glasgowConfig } from "./data";

export default function GlasgowPage() {
  return <CityPageTemplate config={glasgowConfig} />;
}